// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle48Filled: FC<CheckCircle48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="49"
            height="48"
        >
            <path d="m21.495 33.1 14.15-14.15-2.3-2.25-11.85 11.85-6-6-2.25 2.25 8.25 8.3Zm2.95 10.9c-2.733 0-5.317-.525-7.75-1.575-2.433-1.05-4.558-2.483-6.375-4.3-1.817-1.817-3.25-3.942-4.3-6.375-1.05-2.433-1.575-5.017-1.575-7.75 0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.483-4.55 4.3-6.35 1.817-1.8 3.942-3.225 6.375-4.275C19.128 4.525 21.712 4 24.445 4c2.767 0 5.367.525 7.8 1.575 2.433 1.05 4.55 2.475 6.35 4.275 1.8 1.8 3.225 3.917 4.275 6.35 1.05 2.433 1.575 5.033 1.575 7.8 0 2.733-.525 5.317-1.575 7.75-1.05 2.433-2.475 4.558-4.275 6.375-1.8 1.817-3.917 3.25-6.35 4.3-2.433 1.05-5.033 1.575-7.8 1.575Z" />
        </svg>
    );
};

export default CheckCircle48Filled;
